export type ContactOptionId =
  | 'spareParts'
  | 'paldeskSupport'
  | 'paldeskEmail'
  | 'findDealer'
  | 'palfingerAg'
  | 'palfingerMarine';

export type HelpRegion = 'EMEA' | 'LATAM' | 'OTHER';

export interface HelpContext {
  insidePaldesk: boolean;
  loggedIn: boolean;
  isPartnerOrDealer: boolean;
  region: HelpRegion;
}

const SPARE_PARTS_REGIONS = new Set<HelpRegion>(['EMEA', 'LATAM']);

/** Mirrors docs/contact-human-help-flow.md in CoreServices.Palchat. */
export function resolveContactOptions(c: HelpContext): ContactOptionId[] {
  if (!c.insidePaldesk) {
    return ['findDealer', 'palfingerAg', 'palfingerMarine'];
  }
  if (!c.loggedIn) {
    return ['paldeskEmail', 'findDealer', 'palfingerAg', 'palfingerMarine'];
  }
  if (!c.isPartnerOrDealer) {
    return ['paldeskSupport', 'findDealer', 'palfingerAg', 'palfingerMarine'];
  }
  return SPARE_PARTS_REGIONS.has(c.region)
    ? ['spareParts', 'paldeskSupport', 'palfingerAg', 'palfingerMarine']
    : ['paldeskSupport', 'palfingerAg', 'palfingerMarine'];
}
